import { useMemo } from 'react';

import { matchPath, useLocation } from 'react-router-dom';

export const useRouteMatch = (props) => {
  let path;
  let strict = false;
  let routes;

  if (typeof props === 'object') {
    /* eslint-disable prefer-destructuring */
    path = props.path;
    strict = props.strict;
    routes = props.routes;
    /* eslint-enable prefer-destructuring */
  } else if (typeof props === 'string') {
    path = props;
  }

  const { pathname } = useLocation();

  return useMemo(() => {
    let result = null;

    if (!routes) {
      result = matchPath(pathname, { path, strict });
    } else {
      const entries = Object.entries(routes);

      for (const [route, params] of entries) {
        result = matchPath(pathname, params);

        if (result) {
          Object.assign(result, { route });

          break;
        }
      }
    }

    return result;
  }, [routes, pathname, path, strict]);
};
